import { Component, ElementRef, Input, AfterViewInit } from '@angular/core';
import * as c3 from 'c3';
import * as d3 from 'd3';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-donut-chart',
    templateUrl: './donut-chart.component.html',
    styleUrls: ['./donut-chart.component.scss'],
    standalone: false
})
export class DonutChartComponent implements AfterViewInit {
  @Input() changing: Subject<any>;
  @Input() from: string = 'main';
  chart: any;
  total = 0;
  classification: string;
  constructor(private elRef: ElementRef) { }

  ngAfterViewInit() {
    this.changing.subscribe(v => {
      this.generateDonutChart(v);
      this.paramtotal(v);
      if (v.classification === null) {
        this.classification = 'totalparam';
      } else {
        this.classification = v.classification;
      }
    });
  }

  generateDonutChart(data: any) {

    this.chart = c3.generate({
      bindto: this.elRef.nativeElement.children[1],
      legend: {
        show: true
      },
      padding: {
        top: 25,
        right: 25,
        bottom: 0,
        left: 0,
      },
      data: {
        columns:
          [
            ['data1', data.criticalityE],
            ['data2', data.criticalityD],
            ['data3', data.criticalityC],
            ['data4', data.criticalityB],
            ['data5', data.criticalityA],
            ['data6', data.criticalityF],
          ],
        names: {
          data1: '>1.67',
          data2: '1.33-1.67',
          data3: '1-1.33',
          data4: '0.67-1',
          data5: '<0.67',
          data6: "null, \u221E"
        },
        colors: {
          data6: 'grey',
          data5: '#ED4343',
          data4: '#FF8900',
          data3: '#FFBA00',
          data2: '#BBC300',
          data1: '#0FBE52'
        },
        type: 'donut'
      },
      donut: {
        label: {
          show: false
        },
        width: 15,
        expand: true
      },
      transition: {
        duration: 4000,
      },

    });
  }

  paramtotal(data: any) {
    this.total = data.criticalityA + data.criticalityB + data.criticalityC + data.criticalityD + data.criticalityE + data.criticalityF;
  }
}
